import { gql } from "@apollo/client"

import {
    NewPartnershipTierSelectorItemTierFragment,
    NewPartnershipTierSelectorItemApplylistFragment,
} from "./variants/New/fragment"
import {
    ChangePartnershipTierSelectorItemTierFragment,
    ChangePartnershipTierSelectorItemApplylistFragment,
} from "./variants/Change/fragments"

export const PartnershipTierSelectorItemTierFragment = gql`
    fragment PartnershipTierSelectorItemTierFragment on CollectivePassType {
        id
        ...NewPartnershipTierSelectorItemTierFragment
        ...ChangePartnershipTierSelectorItemTierFragment
    }
    ${NewPartnershipTierSelectorItemTierFragment}
    ${ChangePartnershipTierSelectorItemTierFragment}
`

export const PartnershipTierSelectorItemApplylistFragment = gql`
    fragment PartnershipTierSelectorItemApplylistFragment on ApplylistType {
        id
        partnership {
            id
            canRepurchase
        }
        ...NewPartnershipTierSelectorItemApplylistFragment
        ...ChangePartnershipTierSelectorItemApplylistFragment
    }
    ${NewPartnershipTierSelectorItemApplylistFragment}
    ${ChangePartnershipTierSelectorItemApplylistFragment}
`
